import {
  COURSE_ADD,
  COURSE_ADD_SUCCESS,
  COURSE_ADD_ERROR,
  COURSE_LIST,
  COURSE_LIST_SUCCESS,
  COURSE_LIST_ERROR,
  COURSE_GET,
  COURSE_GET_SUCCESS,
  COURSE_GET_ERROR,
  COURSE_EDIT,
  COURSE_EDIT_SUCCESS,
  COURSE_EDIT_ERROR,
  COURSE_UPDATE_ATTRIBUTE,
  COURSE_PATCH,
  COURSE_PATCH_SUCCESS,
  COURSE_PATCH_ERROR,
  COURSE_REPORT,
  COURSE_REPORT_SUCCESS,
  COURSE_REPORT_ERROR,
  QUESTION_PAYMENT_DATA_UPDATE,
  QUESTION_PAYMENT_DISCONNECT,
  COURSE_SETTING_PATCH,
  COURSE_SETTING_PATCH_SUCCESS,
  COURSE_SETTING_PATCH_ERROR,
  COURSE_SETTING_CREATE,
  COURSE_SETTING_CREATE_SUCCESS,
  COURSE_SETTING_CREATE_ERROR,
  COURSE_SETTING_PATCH_BY_ID,
  COURSE_SETTING_PATCH_BY_ID_SUCCESS,
  COURSE_SETTING_PATCH_BY_ID_ERROR,
  OPENAI_SEND_CARD_REQUEST_ERROR,
  OPENAI_SEND_CARD_REQUEST_SUCCESS,
  OPENAI_SEND_CARD_REQUEST,
  OPENAI_SEND_COURSE_CREATION_GET_TITLE_REQUEST,
  OPENAI_SEND_COURSE_CREATION_GET_TITLE_REQUEST_SUCCESS,
  OPENAI_SEND_COURSE_CREATION_GET_TITLE_REQUEST_ERROR,
  OPENAI_SEND_COURSE_CREATION_GET_OUTLINE_REQUEST,
  OPENAI_SEND_COURSE_CREATION_GET_OUTLINE_REQUEST_SUCCESS,
  OPENAI_SEND_COURSE_CREATION_GET_OUTLINE_REQUEST_ERROR,
  OPENAI_SEND_COURSE_CREATION_REQUEST,
  OPENAI_SEND_COURSE_CREATION_REQUEST_SUCCESS,
  OPENAI_SEND_COURSE_CREATION_REQUEST_ERROR,
  CLONE_TEMPLATE_COURSE,
  CLONE_TEMPLATE_COURSE_SUCCESS,
  CLONE_TEMPLATE_COURSE_ERROR,
  CREATE_PROMPT_FROM_CARD,
  CREATE_PROMPT_FROM_CARD_SUCCESS,
  CREATE_PROMPT_FROM_CARD_ERROR,
  GET_COURSE_ANALYTICS,
  GET_COURSE_ANALYTICS_SUCCESS,
  GET_COURSE_ANALYTICS_ERROR,
  GET_COURSE_ANALYTICS_REPORT,
  GET_COURSE_ANALYTICS_REPORT_SUCCESS,
  GET_COURSE_ANALYTICS_REPORT_ERROR,
  GENERATE_QUIZZES_BY_COURSE_ID,
  GENERATE_QUIZZES_BY_COURSE_ID_SUCCESS,
  GENERATE_QUIZZES_BY_COURSE_ID_ERROR,
  EXPORT_COURSE_TO_SCORM,
  EXPORT_COURSE_TO_SCORM_SUCCESS,
  EXPORT_COURSE_TO_SCORM_ERROR,
  SETTINGS_DRAWER_OPEN,
  GET_COURSE_CREATION_PROGRESS,
  GET_COURSE_CREATION_PROGRESS_SUCCESS,
  GET_COURSE_CREATION_PROGRESS_ERROR,
  THEME_DRAWER_OPEN,
  SECTION_DRAWER_OPEN,
  EDIT_SECTION_ORDER,
  EDIT_SECTION_ORDER_SUCCESS,
  EDIT_SECTION_ORDER_ERROR,
  PATCH_SECTION,
  PATCH_SECTION_SUCCESS,
  PATCH_SECTION_ERROR,
  ADD_SECTION,
  ADD_SECTION_SUCCESS,
  ADD_SECTION_ERROR,
  ANALYTICS_DRAWER_OPEN,
  SET_ENDING_CARD,
  CREATE_COURSE,
  CREATE_COURSE_SUCCESS,
  CREATE_COURSE_ERROR,
  GET_COURSE_BY_ID,
  GET_COURSE_BY_ID_SUCCESS,
  GET_COURSE_BY_ID_ERROR,
  GENERATE_CARD,
  GENERATE_CARD_SUCCESS,
  GENERATE_CARD_ERROR,
  SET_CARD_CREATION_PROGRESS,
  SET_CARD_CREATION_PROGRESS_VALUE,
  GET_COURSE_LANDING_PAGE,
  GET_COURSE_LANDING_PAGE_SUCCESS,
  GET_COURSE_LANDING_PAGE_ERROR,
  PATCH_COURSE_LANDING_PAGE,
  PATCH_COURSE_LANDING_PAGE_SUCCESS,
  PATCH_COURSE_LANDING_PAGE_ERROR,
  COURSE_FILTER,
  COURSE_FILTER_SUCCESS,
  COURSE_FILTER_ERROR,
  UPLOAD_VIDEO_SUBTITLE,
  UPLOAD_VIDEO_SUBTITLE_SUCCESS,
  DELETE_VIDEO_SUBTITLE,
  DELETE_VIDEO_SUBTITLE_SUCCESS,
  PATCH_VIDEO_SUBTITLE,
  GET_VIDEO_SUBTITLES,
  GET_VIDEO_SUBTITLES_SUCCESS,
} from './type'

/**
 *
 * @param {*} query
 */
export const courseListAction = (query, callback) => {
  return {
    type: COURSE_LIST,
    payload: { query, callback },
  }
}

/**
 *
 * @param {*} response
 */
export const courseListSuccess = response => {
  return {
    type: COURSE_LIST_SUCCESS,
    payload: { response },
  }
}

/**
 *
 */
export const courseListError = () => {
  return {
    type: COURSE_LIST_ERROR,
  }
}

/**
 *
 * @param {*} id
 */
export const courseGetAction = (id, callback) => {
  return {
    type: COURSE_GET,
    payload: { id, callback },
  }
}

/**
 *
 * @param {*} entity
 */
export const courseGetSuccess = entity => {
  return {
    type: COURSE_GET_SUCCESS,
    payload: { entity },
  }
}

/**
 *
 */
export const courseGetError = () => {
  return {
    type: COURSE_GET_ERROR,
  }
}

/**
 *
 * @param {*} entity
 * @param {*} callback
 */
export const courseAddAction = (entity, history, callback) => {
  return {
    type: COURSE_ADD,
    payload: { entity, history, callback },
  }
}

/**
 *
 * @param {*} entity
 */
export const courseAddSuccess = entity => {
  return {
    type: COURSE_ADD_SUCCESS,
    payload: { entity },
  }
}

/**
 *
 */
export const courseAddError = () => {
  return {
    type: COURSE_ADD_ERROR,
  }
}

/**
 *
 * @param {*} entity
 */
export const courseEditAction = (entity, callback) => {
  return {
    type: COURSE_EDIT,
    payload: { entity, callback },
  }
}

/**
 *
 * @param {*} entity
 */
export const courseEditSuccess = entity => {
  return {
    type: COURSE_EDIT_SUCCESS,
    payload: { entity },
  }
}

/**
 *
 */
export const courseEditError = () => {
  return {
    type: COURSE_EDIT_ERROR,
  }
}

export const courseUpdateAttribute = (content, callback) => {
  return {
    type: COURSE_UPDATE_ATTRIBUTE,
    payload: { content, callback },
  }
}
/**
 *
 * @param {*} content
 * @param {*} callback
 */
export const coursePatchAction = (content, callback) => {
  return {
    type: COURSE_PATCH,
    payload: { content, callback },
  }
}

/**
 *
 * @param {*} content
 */
export const coursePatchSuccess = content => {
  return {
    type: COURSE_PATCH_SUCCESS,
    payload: { content },
  }
}

/**
 *
 */
export const coursePatchError = () => {
  return {
    type: COURSE_PATCH_ERROR,
  }
}

export const courseReportAction = id => {
  return {
    type: COURSE_REPORT,
    payload: { id },
  }
}

/**
 *
 * @param {*} response
 */
export const courseReportSuccess = () => {
  return {
    type: COURSE_REPORT_SUCCESS,
    payload: {},
  }
}

/**
 *
 */
export const courseReportError = () => {
  return {
    type: COURSE_REPORT_ERROR,
  }
}

export const questionPaymentDataChangeAction = content => {
  return {
    type: QUESTION_PAYMENT_DATA_UPDATE,
    payload: { content },
  }
}

export const questionPaymentDisconnectAction = cardId => {
  return {
    type: QUESTION_PAYMENT_DISCONNECT,
    payload: { cardId },
  }
}

export const courseSettingPatch = (
  content,
  settingId,
  questionId,
  key,
  callback,
) => {
  return {
    type: COURSE_SETTING_PATCH,
    payload: { content, settingId, questionId, key, callback },
  }
}

export const courseSettingPatchSuccess = (
  content,
  settingId,
  key,
  questionId,
) => {
  return {
    type: COURSE_SETTING_PATCH_SUCCESS,
    payload: { content, settingId, key, questionId },
  }
}

export const courseSettingPatchError = () => {
  return {
    type: COURSE_SETTING_PATCH_ERROR,
  }
}

export const courseSettingCreate = (content, questionId, callback) => {
  return {
    type: COURSE_SETTING_CREATE,
    payload: { content, questionId, callback },
  }
}

export const courseSettingPatchById = (courseId, settingId, data, callback) => {
  return {
    type: COURSE_SETTING_PATCH_BY_ID,
    payload: { courseId, settingId, data, callback },
  }
}

export const courseSettingPatchByIdSuccess = (courseId, settingId, data) => {
  return {
    type: COURSE_SETTING_PATCH_BY_ID_SUCCESS,
    payload: { courseId, settingId, data },
  }
}

export const courseSettingCreateSuccess = (content, questionId) => {
  return {
    type: COURSE_SETTING_CREATE_SUCCESS,
    payload: { content, questionId },
  }
}

export const courseSettingCreateError = () => {
  return {
    type: COURSE_SETTING_CREATE_ERROR,
  }
}

/**
 * @param {*} starterText
 * @param {*} courseId
 * @param {*} cardId
 * @param {*} callback
 */
export const openaiSendCardRequestAction = (
  starterText,
  courseId,
  cardId,
  callback,
) => {
  return {
    type: OPENAI_SEND_CARD_REQUEST,
    payload: { starterText, courseId, cardId, callback },
  }
}

/**
 *
 * @param {*} entity
 */
export const openaiSendCardRequestSuccess = entity => {
  return {
    type: OPENAI_SEND_CARD_REQUEST_SUCCESS,
    payload: { entity },
  }
}

/**
 *
 */
export const openaiSendCardRequestError = () => {
  return {
    type: OPENAI_SEND_CARD_REQUEST_ERROR,
  }
}

/**
 * @param {*} profession
 * @param {*} audience
 * @param {*} title
 * @param {*} description
 * @param {*} purpose
 * @param {*} callback
 */
export const openaiSendCourseCreationGetTitleRequestAction = (
  profession,
  audience,
  description,
  language,
  purpose,
  callback,
) => {
  return {
    type: OPENAI_SEND_COURSE_CREATION_GET_TITLE_REQUEST,
    payload: { profession, audience, description, language, purpose, callback },
  }
}

/**
 *
 * @param {*} entity
 */
export const openaiSendCourseCreationGetTitleRequestSuccess = entity => {
  return {
    type: OPENAI_SEND_COURSE_CREATION_GET_TITLE_REQUEST_SUCCESS,
    payload: { entity },
  }
}

/**
 *
 */
export const openaiSendCourseCreationGetTitleRequestError = () => {
  return {
    type: OPENAI_SEND_COURSE_CREATION_GET_TITLE_REQUEST_ERROR,
  }
}

/**
 * @param {*} profession,
 * @param {*} audience,
 * @param {*} title,
 * @param {*} language,
 * @param {*} callback
 */
export const openaiSendCourseCreationGetOutlineRequestAction = (
  profession,
  audience,
  title,
  language,
  purpose,
  callback,
) => {
  return {
    type: OPENAI_SEND_COURSE_CREATION_GET_OUTLINE_REQUEST,
    payload: { profession, audience, title, language, purpose, callback },
  }
}

/**
 *
 * @param {*} entity
 */
export const openaiSendCourseCreationGetOutlineRequestSuccess = entity => {
  return {
    type: OPENAI_SEND_COURSE_CREATION_GET_OUTLINE_REQUEST_SUCCESS,
    payload: { entity },
  }
}

/**
 *
 */
export const openaiSendCourseCreationGetOutlineRequestError = () => {
  return {
    type: OPENAI_SEND_COURSE_CREATION_GET_OUTLINE_REQUEST_ERROR,
  }
}
/**
 * @param {*} firstCardText
 * @param {*} title
 * @param {*} outlines
 * @param {*} description
 * @param {*} profession
 * @param {*} courseCollectionId
 * @param {*} themeSettings
 * @param {*} purpose
 * @param {*} selectedPreset
 * @param {*} imageGenerator
 * @param {*} callback
 */
export const openaiSendCourseCreationRequestAction = (
  title,
  outlines,
  profession,
  audience,
  description,
  themeSettings,
  courseCollectionId,
  variables,
  gatewaySelection,
  language,
  purpose,
  imageGenerator,
  generateImage,
  callback,
) => {
  return {
    type: OPENAI_SEND_COURSE_CREATION_REQUEST,
    payload: {
      title,
      outlines,
      profession,
      audience,
      description,
      themeSettings,
      courseCollectionId,
      variables,
      gatewaySelection,
      language,
      purpose,
      imageGenerator,
      generateImage,
      callback,
    },
  }
}

/**
 *
 * @param {*} code
 * @param {*} title
 * @param {*} collectionId
 * @param {*} callback
 */
export const cloneTemplateCourseAction = (
  code,
  title,
  collectionId,
  callback,
) => {
  return {
    type: CLONE_TEMPLATE_COURSE,
    payload: { code, title, collectionId, callback },
  }
}

/**
 *
 * @param {*} entity
 */

export const openaiSendCourseCreationRequestSuccess = entity => {
  return {
    type: OPENAI_SEND_COURSE_CREATION_REQUEST_SUCCESS,
    payload: { entity },
  }
}

export const courseCloneSuccess = response => {
  return {
    type: CLONE_TEMPLATE_COURSE_SUCCESS,
    payload: { response },
  }
}

/**
 *
 */
export const openaiSendCourseCreationRequestError = () => {
  return {
    type: OPENAI_SEND_COURSE_CREATION_REQUEST_ERROR,
  }
}

export const courseCloneError = () => {
  return {
    type: CLONE_TEMPLATE_COURSE_ERROR,
  }
}

/**
 *
 * @param {*} starterText
 */
export const createPromptFromCardAction = (starterText, callback) => {
  return {
    type: CREATE_PROMPT_FROM_CARD,
    payload: { starterText, callback },
  }
}

export const createPromptFromCardSuccess = response => {
  return {
    type: CREATE_PROMPT_FROM_CARD_SUCCESS,
    payload: { response },
  }
}

/**
 *
 */
export const createPromptFromCardError = () => {
  return {
    type: CREATE_PROMPT_FROM_CARD_ERROR,
  }
}

/**
 *
 * @param {*} courseId
 * @param {*} callback
 */
export const getCourseAnalyticsByIdAction = (courseId, callback) => {
  return {
    type: GET_COURSE_ANALYTICS,
    payload: { courseId, callback },
  }
}

export const getCourseAnalyticsByIdSuccess = response => {
  return {
    type: GET_COURSE_ANALYTICS_SUCCESS,
    payload: { response },
  }
}

/**
 *
 */
export const getCourseAnalyticsByIdError = () => {
  return {
    type: GET_COURSE_ANALYTICS_ERROR,
  }
}

/**
 *
 * @param {*} courseId
 * @param {*} callback
 */
export const getCourseAnalyticsReportAction = (courseId, callback) => {
  return {
    type: GET_COURSE_ANALYTICS_REPORT,
    payload: { courseId, callback },
  }
}

export const getCourseAnalyticsReportSuccess = response => {
  return {
    type: GET_COURSE_ANALYTICS_REPORT_SUCCESS,
    payload: { response },
  }
}

/**
 *
 */
export const getCourseAnalyticsReportError = () => {
  return {
    type: GET_COURSE_ANALYTICS_REPORT_ERROR,
  }
}

/**
 *
 * @param {*} courseId
 * @param {*} callback
 */
export const generateQuizzesByCourseIdAction = (courseId, callback) => {
  return {
    type: GENERATE_QUIZZES_BY_COURSE_ID,
    payload: { courseId, callback },
  }
}

/**
 *
 * @param {*} response
 */
export const generateQuizzesByCourseIdSuccess = response => {
  return {
    type: GENERATE_QUIZZES_BY_COURSE_ID_SUCCESS,
    payload: { response },
  }
}

/**
 *
 */
export const generateQuizzesByCourseIdError = () => {
  return {
    type: GENERATE_QUIZZES_BY_COURSE_ID_ERROR,
  }
}

/**
 *
 * @param {*} id
 * @param {*} scormVersion
 */

export const exportCourseToScormAction = (
  courseName,
  id,
  scormVersion,
  callback,
) => {
  return {
    type: EXPORT_COURSE_TO_SCORM,
    payload: { courseName, id, scormVersion, callback },
  }
}

/**
 *
 * @param {*} response
 */
export const exportCourseToScormSuccess = response => {
  return {
    type: EXPORT_COURSE_TO_SCORM_SUCCESS,
    payload: { response },
  }
}

/**
 *
 */
export const exportCourseToScormError = () => {
  return {
    type: EXPORT_COURSE_TO_SCORM_ERROR,
  }
}

/**
 *
 */
export const settingsDrawerOpenSuccess = () => {
  return {
    type: SETTINGS_DRAWER_OPEN,
  }
}

/**
 *
 * @param {*} id
 * @param {*} callback
 */

export const getCourseCreationProgressAction = (id, callback) => {
  return {
    type: GET_COURSE_CREATION_PROGRESS,
    payload: { id, callback },
  }
}

/**
 *
 * @param {*} response
 */
export const getCourseCreationProgressSuccess = response => {
  return {
    type: GET_COURSE_CREATION_PROGRESS_SUCCESS,
    payload: { response },
  }
}

/**
 *
 */
export const getCourseCreationProgressError = () => {
  return {
    type: GET_COURSE_CREATION_PROGRESS_ERROR,
  }
}

/**
 *
 *
 */

export const themeDrawerOpen = () => {
  return {
    type: THEME_DRAWER_OPEN,
  }
}

export const sectionDrawerOpen = () => {
  return {
    type: SECTION_DRAWER_OPEN,
  }
}

export const editSectionOrderAction = (id, sections, callback) => {
  return {
    type: EDIT_SECTION_ORDER,
    payload: { id, sections, callback },
  }
}

export const editSectionOrderSuccess = response => {
  return {
    type: EDIT_SECTION_ORDER_SUCCESS,
    payload: { response },
  }
}

export const editSectionOrderError = () => {
  return {
    type: EDIT_SECTION_ORDER_ERROR,
  }
}

export const patchSectionAction = (content, callback) => {
  return {
    type: PATCH_SECTION,
    payload: { content, callback },
  }
}

export const patchSectionSuccess = response => {
  return {
    type: PATCH_SECTION_SUCCESS,
    payload: { response },
  }
}

export const patchSectionError = () => {
  return {
    type: PATCH_SECTION_ERROR,
  }
}

export const addSectionAction = (entity, callback) => {
  return {
    type: ADD_SECTION,
    payload: { entity, callback },
  }
}

export const addSectionSuccess = entity => {
  return {
    type: ADD_SECTION_SUCCESS,
    payload: { entity },
  }
}

export const addSectionError = () => {
  return {
    type: ADD_SECTION_ERROR,
  }
}

export const analyticsDrawerOpen = () => {
  return {
    type: ANALYTICS_DRAWER_OPEN,
  }
}

export const setEndingCard = content => {
  return {
    type: SET_ENDING_CARD,
    payload: { content },
  }
}

export const createCourseAction = (data, callback) => {
  return {
    type: CREATE_COURSE,
    payload: { data, callback },
  }
}

export const createCourseSuccess = response => {
  return {
    type: CREATE_COURSE_SUCCESS,
    payload: { response },
  }
}

export const createCourseError = () => {
  return {
    type: CREATE_COURSE_ERROR,
  }
}

export const getCourseByIdAction = (id, callback) => {
  return {
    type: GET_COURSE_BY_ID,
    payload: { id, callback },
  }
}

export const getCourseByIdSuccess = response => {
  return {
    type: GET_COURSE_BY_ID_SUCCESS,
    payload: { response },
  }
}

export const getCourseByIdError = () => {
  return {
    type: GET_COURSE_BY_ID_ERROR,
  }
}

export const generateCardAction = (data, callback) => {
  return {
    type: GENERATE_CARD,
    payload: { data, callback },
  }
}

export const generateCardSuccess = response => {
  return {
    type: GENERATE_CARD_SUCCESS,
    payload: { response },
  }
}

export const generateCardError = () => {
  return {
    type: GENERATE_CARD_ERROR,
  }
}

export const setCardCreationProgress = isInProgress => ({
  type: SET_CARD_CREATION_PROGRESS,
  payload: isInProgress,
})

export const setCardCreationProgressValue = value => ({
  type: SET_CARD_CREATION_PROGRESS_VALUE,
  payload: value,
})

export const getCourseLandingPageAction = (id, callback) => {
  return {
    type: GET_COURSE_LANDING_PAGE,
    payload: { id, callback },
  }
}

export const getCourseLandingPageSuccess = response => {
  return {
    type: GET_COURSE_LANDING_PAGE_SUCCESS,
    payload: { response },
  }
}

export const getCourseLandingPageError = () => {
  return {
    type: GET_COURSE_LANDING_PAGE_ERROR,
  }
}

export const patchCourseLandingPageAction = (id, data, callback) => {
  return {
    type: PATCH_COURSE_LANDING_PAGE,
    payload: { id, data, callback },
  }
}

export const patchCourseLandingPageSuccess = response => {
  return {
    type: PATCH_COURSE_LANDING_PAGE_SUCCESS,
    payload: { response },
  }
}

export const patchCourseLandingPageError = () => {
  return {
    type: PATCH_COURSE_LANDING_PAGE_ERROR,
  }
}

export const courseFilterAction = (data, callback) => {
  return {
    type: COURSE_FILTER,
    payload: { data, callback },
  }
}

export const courseFilterSuccess = response => {
  return {
    type: COURSE_FILTER_SUCCESS,
    payload: { response },
  }
}

export const courseFilterError = () => {
  return {
    type: COURSE_FILTER_ERROR,
  }
}

export const uploadVideoSubtitleAction = (shopClipId, videoUrl, subtitleFile, language, label, isDefault, callback) => {
  return {
    type: UPLOAD_VIDEO_SUBTITLE,
    payload: { shopClipId, videoUrl, subtitleFile, language, label, isDefault, callback },
  }
}

export const uploadVideoSubtitleSuccess = (videoId, subtitleData) => {
  return {
    type: UPLOAD_VIDEO_SUBTITLE_SUCCESS,
    payload: { videoId, subtitleData },
  }
}

export const deleteVideoSubtitleAction = (shopClipId, videoUrl, language, callback) => {
  return {
    type: DELETE_VIDEO_SUBTITLE,
    payload: { shopClipId, videoUrl, language, callback },
  }
}

export const deleteVideoSubtitleSuccess = (videoId, language) => {
  return {
    type: DELETE_VIDEO_SUBTITLE_SUCCESS,
    payload: { videoId, language },
  }
}

export const getVideoSubtitlesAction = (shopClipId, videoUrl, callback) => {
  return {
    type: GET_VIDEO_SUBTITLES,
    payload: { shopClipId, videoUrl, callback },
  }
}

export const getVideoSubtitlesSuccess = (videoId, subtitles) => {
  return {
    type: GET_VIDEO_SUBTITLES_SUCCESS,
    payload: { videoId, subtitles },
  }
}

export const patchVideoSubtitleAction = (shopClipId, videoUrl, language, patchBody, callback) => {
  return {
    type: PATCH_VIDEO_SUBTITLE,
    payload: { shopClipId, videoUrl, language, patchBody, callback },
  }
}
